// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"styles_mainContainer__3g1TP","pageTitle":"styles_pageTitle__LWXAW","backButton":"styles_backButton__1HRO0"};